export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5118.1ae6cc6b.jpg";